/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_No_OrdersInputs */

const vi_station_no_orders = /** @type {(inputs: Station_No_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn hàng cần xử lý`)
};

/**

* @param {Station_No_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_no_orders = /** @type {((inputs?: Station_No_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_No_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_no_orders(inputs)
});